import React from 'react';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { formatDateTime } from '../../utils/datetime';
import { useMutation } from '@apollo/client';
import { SEND_LEGAL_PERSON_SNAIL_MAIL_VERIFICATION } from '../../graphql/mutations/legalPerson';

interface LegalPersonVerificationDetailModalProps {
    isOpen: boolean;
    onClose: () => void;
    verificationDetailData: any;
    fieldName: string;
}

const LegalPersonVerificationDetailModal: React.FC<LegalPersonVerificationDetailModalProps> = ({ isOpen, onClose, verificationDetailData, fieldName }) => {
    // const legalPersonInfo = useSelector((state: RootState) => state.legalPerson);
    console.log("verificationDetailData   :    ", verificationDetailData);
    const { t } = useTranslation('verification');
    const [sendLegalPersonSnailMail, { loading: sendingSnailMail }] = useMutation(SEND_LEGAL_PERSON_SNAIL_MAIL_VERIFICATION);
    
    const handleSendSnailMail = () => {
        if (verificationDetailData && verificationDetailData.id) {
            if (window.confirm('郵送確認を行いますか？')) {
                sendLegalPersonSnailMail({
                    variables: {
                        externalId: verificationDetailData.id
                    }
                }).then((res) => {
                    console.log('Snail mail verification sent:', res);
                    // You could add a success message or other UI feedback here
                }).catch((error) => {
                    console.error('Error sending snail mail verification:', error);
                    // You could add error handling here
                });
            }
        }
    };
    
    if (!isOpen) return null;

    const renderContent = () => {
        let reasonDetailFields;
        switch(fieldName) {
            case 'legalPersonVerification':
                reasonDetailFields= verificationDetailData.legalPersonVerification_reasonDetailFields ? verificationDetailData.legalPersonVerification_reasonDetailFields
                        .replace(/[\[\]\s]/g, '')
                        .replace('.0.', '_')
                        .split(',')
                    : null;
                return (
                    <div>
                        <h2><i>{t('legal person verification status')}</i></h2>
                        <p>
                            <strong>{t('public id')} : </strong>
                            <span>{verificationDetailData.legalPersonVerification_verificationPublicId}</span>
                        </p>
                        <p>
                            <strong>{t('legal person verification method')} : </strong>
                            <span>{t(verificationDetailData.legalPersonVerification_verificationMethod)}</span>
                        </p>
                        <p>
                            <strong>{t('received datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.legalPersonVerification_receivedDate)}</span>
                        </p>
                        <p>
                            <strong>{t('updated datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.legalPersonVerification_updatedDate)}</span>
                        </p>
                        <p>
                            <strong>{t('verified datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.legalPersonVerification_verificationDate)}</span>
                        </p>
                        <p>
                            <strong>{t('status')} : </strong>
                            <span>{t(verificationDetailData.legalPersonVerification_status)}</span>
                        </p>
                        {verificationDetailData.legalPersonVerification_result && (
                            <p>
                                <strong>{t('result')} : </strong>
                                <span>{t(verificationDetailData.legalPersonVerification_result)}</span>
                            </p>
                        )}
                        {verificationDetailData.legalPersonVerification_result === "denied" && (
                            <p>
                                <strong>{t('reason')} : </strong>
                                <span>{t(verificationDetailData.legalPersonVerification_reasonCode)}</span>
                                <br/>
                                {reasonDetailFields && (
                                    <span>（ </span>
                                )}
                                {reasonDetailFields && reasonDetailFields.map((reasonDetailField: any, index: number) => (
                                    <span>{t(reasonDetailField)} </span>
                                ))}
                                {reasonDetailFields && (
                                    <span>）</span>
                                )}
                            </p>
                        )}
                        <br/>
                        <p>
                            <a className="no-underline hover:underline"
                               href={`${process.env.REACT_APP_TRUSTDOCK_OPERATION_URL}/verification/inspections?verification_inspection_search%5Bverification_id%5D=${
                                   verificationDetailData.legalPersonVerification_verificationId
                               }&verification_inspection_search%5Bconditional_search%5D=0&verification_inspection_search%5Bmishandle_search%5D=0&commit=%E6%A4%9C%E7%B4%A2`}
                               target="_blank"><strong>{t('id search')}</strong></a>
                        </p>
                    </div>
                );

            case 'personalVerification':
                reasonDetailFields= verificationDetailData.personalVerification_reasonDetailFields ? verificationDetailData.personalVerification_reasonDetailFields
                        .replace(/[\[\]\s]/g, '')
                        .split(',')
                    : null;
                return (
                    <div>
                        <h2><i>{t('personal verification status')}</i></h2>
                        <p>
                            <strong>{t('public id')} : </strong>
                            <span>{verificationDetailData.personalVerification_verificationPublicId}</span>
                        </p>
                        <p>
                            <strong>{t('personal verification method')} : </strong>
                            <span>{t(verificationDetailData.personalVerification_verificationMethod)}</span>
                        </p>
                        <p>
                            <strong>{t('personal verification document')} : </strong>
                            <span>{t(verificationDetailData.personalVerification_verificationDocumentType)}</span>
                        </p>
                        <p>
                            <strong>{t('received datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.personalVerification_receivedDate)}</span>
                        </p>
                        <p>
                            <strong>{t('updated datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.personalVerification_updatedDate)}</span>
                        </p>
                        <p>
                            <strong>{t('verified datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.personalVerification_verificationDate)}</span>
                        </p>
                        <p>
                            <strong>{t('status')} : </strong>
                            <span>{t(verificationDetailData.personalVerification_status)}</span>
                        </p>
                        {verificationDetailData.personalVerification_result && (
                            <p>
                                <strong>{t('result')} : </strong>
                                <span>{t(verificationDetailData.personalVerification_result)}</span>
                            </p>
                        )}
                        {verificationDetailData.personalVerification_result === "denied" && (
                            <p>
                                <strong>{t('reason')} : </strong>
                                <span>{t(verificationDetailData.personalVerification_reasonCode)}</span>
                                <br/>
                                {reasonDetailFields && (
                                    <span>（ </span>
                                )}
                                {reasonDetailFields && reasonDetailFields.map((reasonDetailField: any, index: number) => (
                                    <span>{t(reasonDetailField)} </span>
                                ))}
                                {reasonDetailFields && (
                                    <span>）</span>
                                )}
                            </p>
                        )}
                        <br/>
                        <p>
                            <a className="no-underline hover:underline"
                               href={`${process.env.REACT_APP_TRUSTDOCK_OPERATION_URL}/verification/inspections?verification_inspection_search%5Bverification_id%5D=${
                                   verificationDetailData.personalVerification_verificationId
                               }&verification_inspection_search%5Bconditional_search%5D=0&verification_inspection_search%5Bmishandle_search%5D=0&commit=%E6%A4%9C%E7%B4%A2`}
                               target="_blank"><strong>{t('id search')}</strong></a>
                        </p>
                    </div>
                );

            case 'letterOfAttorney':
                reasonDetailFields= verificationDetailData.letterOfAttorney_reasonDetailFields ? verificationDetailData.letterOfAttorney_reasonDetailFields
                        .replace(/[\[\]\s]/g, '')
                        .split(',')
                    : null;
                return (
                    <div>
                        <h2><i>{t('letter of attorney status')}</i></h2>
                        <p>
                        <strong>{t('public id')} : </strong>
                            <span>{verificationDetailData.letterOfAttorney_verificationPublicId}</span>
                        </p>
                        <p>
                            <strong>{t('received datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.letterOfAttorney_receivedDate)}</span>
                        </p>
                        <p>
                            <strong>{t('updated datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.letterOfAttorney_updatedDate)}</span>
                        </p>
                        <p>
                            <strong>{t('verified datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.letterOfAttorney_verificationDate)}</span>
                        </p>
                        <p>
                            <strong>{t('status')} : </strong>
                            <span>{t(verificationDetailData.letterOfAttorney_status)}</span>
                        </p>
                        {verificationDetailData.letterOfAttorney_result && (
                            <p>
                                <strong>{t('result')} : </strong>
                                <span>{t(verificationDetailData.letterOfAttorney_result)}</span>
                            </p>
                        )}
                        {verificationDetailData.letterOfAttorney_result === "denied" && (
                            <p>
                                <strong>{t('reason')} : </strong>
                                <span>{t(verificationDetailData.letterOfAttorney_reasonCode)}</span>
                            </p>
                        )}
                        <br/>
                        {reasonDetailFields && (
                            <span>（ </span>
                        )}
                        {reasonDetailFields && reasonDetailFields.map((reasonDetailField: any, index: number) => (
                            <span>{t(reasonDetailField)} </span>
                        ))}
                        {reasonDetailFields && (
                            <span>）</span>
                        )}
                        <p>
                            <a className="underline hover:underline"
                               href={`${process.env.REACT_APP_TRUSTDOCK_OPERATION_URL}/verification/inspections?verification_inspection_search%5Bverification_id%5D=${
                                   verificationDetailData.letterOfAttorney_verificationId
                               }&verification_inspection_search%5Bconditional_search%5D=0&verification_inspection_search%5Bmishandle_search%5D=0&commit=%E6%A4%9C%E7%B4%A2`}
                               target="_blank"><strong>{t('id search')}</strong></a>
                        </p>
                    </div>
                );

            case 'amlRiskCheck':
                return (
                    <div>
                        <h2><i>{t('aml risk check status')}</i></h2>
                        <p>
                            <strong>{t('aml risk check id')} : </strong>
                            <span>{verificationDetailData.amlRiskCheck_amlRiskCheckId}</span>
                        </p>
                        <p>
                            <strong>{t('received datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.amlRiskCheck_createdDate)}</span>
                        </p>
                        <p>
                            <strong>{t('updated datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.amlRiskCheck_updatedDate)}</span>
                        </p>
                        <p>
                            <strong>{t('verified datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.amlRiskCheck_completedDate)}</span>
                        </p>
                        <p>
                            <strong>{t('status')} : </strong>
                            <span>{t(verificationDetailData.amlRiskCheck_status)}</span>
                        </p>
                        {verificationDetailData.amlRiskCheck_result && (
                            <p>
                                <strong>{t('result')} : </strong>
                                <span>{t(verificationDetailData.amlRiskCheck_result)}</span>
                            </p>
                        )}
                        {verificationDetailData.amlRiskCheck_result === "need_confirmation" && (
                            <div>
                                <p>
                                    <strong>{t('result_type')} : </strong>
                                    <span>{t(verificationDetailData.amlRiskCheck_resultType)}</span>
                                </p>
                                <p>
                                    <strong>{t('result_matches')} : </strong>
                                    <span>{t(verificationDetailData.amlRiskCheck_resultMatches)}</span>
                                </p>
                                <p>
                                    <strong>{t('count')} : </strong>
                                    <span>{t(verificationDetailData.amlRiskCheck_countFound)}</span>
                                    <br/>
                                </p>
                            </div>
                        )}
                    </div>
                );

            case 'snailMailVerification':
                return (
                    <div>
                        <h2><i>{t('snail mail verification status')}</i></h2>
                        <p>
                            <strong>{t('snail mail delivery id')} : </strong>
                            <span>{verificationDetailData.snailMailVerification_snailMailRequestId}</span>
                        </p>
                        <p>
                            <strong>{t('snail mail inquiry number')} : </strong>
                            <span>{verificationDetailData.snailMailVerification_inquiryNumber}</span>
                        </p>
                        <p>
                            <strong>{t('created datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.snailMailVerification_createdDate)}</span>
                        </p>
                        <p>
                            <strong>{t('updated datetime')} : </strong>
                            <span>{formatDateTime(verificationDetailData.snailMailVerification_updatedDate)}</span>
                        </p>
                        <p>
                            <strong>{t('snail mail delivery status')} : </strong>
                            <span>{t(verificationDetailData.snailMailVerification_deliveryStatus)}</span>
                        </p>
                        {verificationDetailData.snailMailVerification_result && (
                            <p>
                                <strong>{t('result')} : </strong>
                                <span>{t(verificationDetailData.snailMailVerification_result)}</span>
                            </p>
                        )}
                    </div>
                );

            default:
                return (
                    <div>
                        <p>{t('no_data_available')}</p>
                    </div>
                );
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 items-center z-50">
            <div
                className="bg-white my-[15%] mx-auto w-4/5 max-w-lg p-5 border-[#888] rounded text-left text-black">
            <span className="close" onClick={onClose}>×</span>
                <h2><i>{t('detail info')}</i></h2>
                <div>
                    <p>
                        <strong>{t('corporate name')} : </strong>
                        <span>{verificationDetailData.corporateName}</span>
                    </p>
                    <p>
                        <strong>{t('corporate number')} : </strong>
                        <span>{verificationDetailData.corporateNumber}</span>
                    </p>
                    <p>
                        <strong>{t('id')} : </strong>
                        <span>{verificationDetailData.id}</span>
                    </p>
                </div>
                <br/>
                {verificationDetailData && renderContent()}
                <div className='flex flex-row justify-start'>
                    <div className='m-[10px]'>
                        <Button
                            label={t('close')}
                            onClick={onClose}
                        />
                    </div>
                    {verificationDetailData && 
                     verificationDetailData.legalPersonVerification_result === "approved" && 
                     !verificationDetailData.snailMailVerification_snailMailRequestId && (
                        <div className='m-[10px]'>
                            <Button
                                label="郵送確認"
                                onClick={handleSendSnailMail}
                                addedClass={sendingSnailMail ? 'opacity-50 cursor-not-allowed' : ''}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LegalPersonVerificationDetailModal;
